import {
      GET_FORM_C_LIST,
      POST_FORM_C,
      PUT_FORM_C
    } from "../constants/actionTypes";
  
    const defaultState = {
        formCList: []
    };
  
    export default (state = defaultState, action) => {
      try {
        switch (action.type) {
          case GET_FORM_C_LIST:
            return {...state,formCList:[...action.payload]};
          case POST_FORM_C:
            return {...state,formCList:[action.payload]};
          case PUT_FORM_C:
            return {...state,formCList: [...action.payload]};
          default:
            return state;
        }
      } catch (error) {
        throw new Error(error);
      }
    };